// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fade-in {
    animation: fadeIn 1s ease-in-out;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  .zoom-in {
    animation: zoomIn 1.5s ease-in-out;
  }
  
  @keyframes zoomIn {
    from {
      transform: scale(0.8);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
  
  .animated-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  .animated-card:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }

  .btn-primary {
    background: linear-gradient(45deg, #007bff, #0056b3);
    border: none;
    transition: all 0.3s ease-in-out;
  }
  .btn-primary:hover {
    background: linear-gradient(45deg, #0056b3, #003f8a);
    transform: scale(1.05);
  }

/* Reset and general styling */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial, sans-serif;
  overflow-x: hidden; /* Only prevent horizontal scrolling */
  height: 100%; /* Allow full scrolling */
}



.videoTag {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures the video covers the entire container */
  z-index: -1;
}

/* Text Overlay */
.text-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.7);
  animation: fadeIn 2s ease-in-out;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent background for captions */
  padding: 20px;
  border-radius: 10px;
  width: 90%; /* To prevent overflow on smaller screens */
  max-width: 600px; /* Set a max width for larger screens */
}

.animated-text {
  font-size: 3rem;
  animation: fadeInOut 2s ease-in-out infinite;
}

/* Fade-in and Fade-out animation */
@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* Button Style */
.cta-button {
  margin-top: 20px;
  padding: 12px 30px;
  font-size: 1.2rem;
  border-radius: 50px;
  transition: all 0.3s ease;
}

.cta-button:hover {
  transform: scale(1.1);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
}

/* Page Content Below Video */
.page-content {
  min-height: 100vh; /* Allow content below the video area to fill the page */
  padding: 20px;
  text-align: center;
}

/* Responsive Design */
@media (max-width: 768px) {
  /* On smaller screens, adjust font size and button size */
  .animated-text {
    font-size: 2rem;
  }

  .cta-button {
    font-size: 1rem;
    padding: 10px 25px;
  }

  

  /* Adjust the text overlay container on smaller screens */
  .text-overlay {
    padding: 15px;
    width: 80%; /* More space for text */
  }
}

/* Caption Styling */
.caption-text {
  font-size: 1.2rem;
  color: white;
  margin-top: 10px;
  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.7);
}



`, "",{"version":3,"sources":["webpack://./src/Components/Home/Home.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;EAClC;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE;MACE,qBAAqB;MACrB,UAAU;IACZ;IACA;MACE,mBAAmB;MACnB,UAAU;IACZ;EACF;;EAEA;IACE,qDAAqD;EACvD;EACA;IACE,sBAAsB;IACtB,yCAAyC;EAC3C;;EAEA;IACE,oDAAoD;IACpD,YAAY;IACZ,gCAAgC;EAClC;EACA;IACE,oDAAoD;IACpD,sBAAsB;EACxB;;AAEF,8BAA8B;AAC9B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB,EAAE,sCAAsC;EAC1D,YAAY,EAAE,yBAAyB;AACzC;;;;AAIA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,kDAAkD;EACrE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,4CAA4C;EAC5C,gCAAgC;EAChC,8BAA8B,EAAE,6CAA6C;EAC7E,aAAa;EACb,mBAAmB;EACnB,UAAU,EAAE,2CAA2C;EACvD,gBAAgB,EAAE,uCAAuC;AAC3D;;AAEA;EACE,eAAe;EACf,4CAA4C;AAC9C;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB,EAAE,wDAAwD;EAC3E,aAAa;EACb,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,yDAAyD;EACzD;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;;;EAIA,yDAAyD;EACzD;IACE,aAAa;IACb,UAAU,EAAE,wBAAwB;EACtC;AACF;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;AAC7C","sourcesContent":[".fade-in {\r\n    animation: fadeIn 1s ease-in-out;\r\n  }\r\n  \r\n  @keyframes fadeIn {\r\n    from {\r\n      opacity: 0;\r\n    }\r\n    to {\r\n      opacity: 1;\r\n    }\r\n  }\r\n  \r\n  .zoom-in {\r\n    animation: zoomIn 1.5s ease-in-out;\r\n  }\r\n  \r\n  @keyframes zoomIn {\r\n    from {\r\n      transform: scale(0.8);\r\n      opacity: 0;\r\n    }\r\n    to {\r\n      transform: scale(1);\r\n      opacity: 1;\r\n    }\r\n  }\r\n  \r\n  .animated-card {\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  }\r\n  .animated-card:hover {\r\n    transform: scale(1.05);\r\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  .btn-primary {\r\n    background: linear-gradient(45deg, #007bff, #0056b3);\r\n    border: none;\r\n    transition: all 0.3s ease-in-out;\r\n  }\r\n  .btn-primary:hover {\r\n    background: linear-gradient(45deg, #0056b3, #003f8a);\r\n    transform: scale(1.05);\r\n  }\r\n\r\n/* Reset and general styling */\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: Arial, sans-serif;\r\n  overflow-x: hidden; /* Only prevent horizontal scrolling */\r\n  height: 100%; /* Allow full scrolling */\r\n}\r\n\r\n\r\n\r\n.videoTag {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover; /* Ensures the video covers the entire container */\r\n  z-index: -1;\r\n}\r\n\r\n/* Text Overlay */\r\n.text-overlay {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  text-align: center;\r\n  color: white;\r\n  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.7);\r\n  animation: fadeIn 2s ease-in-out;\r\n  background: rgba(0, 0, 0, 0.5); /* Semi-transparent background for captions */\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  width: 90%; /* To prevent overflow on smaller screens */\r\n  max-width: 600px; /* Set a max width for larger screens */\r\n}\r\n\r\n.animated-text {\r\n  font-size: 3rem;\r\n  animation: fadeInOut 2s ease-in-out infinite;\r\n}\r\n\r\n/* Fade-in and Fade-out animation */\r\n@keyframes fadeInOut {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  20% {\r\n    opacity: 1;\r\n  }\r\n  80% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n/* Button Style */\r\n.cta-button {\r\n  margin-top: 20px;\r\n  padding: 12px 30px;\r\n  font-size: 1.2rem;\r\n  border-radius: 50px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.cta-button:hover {\r\n  transform: scale(1.1);\r\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Page Content Below Video */\r\n.page-content {\r\n  min-height: 100vh; /* Allow content below the video area to fill the page */\r\n  padding: 20px;\r\n  text-align: center;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  /* On smaller screens, adjust font size and button size */\r\n  .animated-text {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .cta-button {\r\n    font-size: 1rem;\r\n    padding: 10px 25px;\r\n  }\r\n\r\n  \r\n\r\n  /* Adjust the text overlay container on smaller screens */\r\n  .text-overlay {\r\n    padding: 15px;\r\n    width: 80%; /* More space for text */\r\n  }\r\n}\r\n\r\n/* Caption Styling */\r\n.caption-text {\r\n  font-size: 1.2rem;\r\n  color: white;\r\n  margin-top: 10px;\r\n  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.7);\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
